import { TREND_NOTE, isMeaningfulChange } from '../../constants';

// The rating scale each row is drawn against (1 low .. 6 high), and the
// favorable band shaded at the top of it. Mirrors the scale the single-round
// sections use — a 4 means the same thing here as it does there.
export const SCALE_MIN = 1;
export const SCALE_MAX = 6;
export const BAND_MIN = 4;
export const BAND_MAX = 6;

// Position of a rating along the scale as a 0..100 percentage.
export const scalePct = (value) =>
    ((value - SCALE_MIN) / (SCALE_MAX - SCALE_MIN)) * 100;

export const HEADER_TEXT = {
    title: 'What moved most',
    description: "Each category's All But Self mean at the earlier and the latest 360, sorted by size of change. The favorable band (4+) is shaded.",
    note: TREND_NOTE,
};

export const GROUP_TEXT = {
    improved: 'Improved',
    declined: 'Declined or flat',
};

// A category's change, and how strongly to draw it. The API may hand back its
// own delta computed from unrounded means — which is why a row's delta is
// trusted when present rather than always re-derived from the two shown values.
export const deltaFor = (row) => (row.delta != null ? row.delta : row.latest - row.earlier);

// Improved / declined splits on the sign; muted is about size, so a small
// improvement and a small decline are both drawn faintly.
export const toneFor = (delta) => {
    if (!isMeaningfulChange(delta)) return 'muted';
    return delta > 0 ? 'up' : 'down';
};
